<div class="cookie-checkbox-container row" *ngIf="settings">
  <mui-checkbox
    id="cookies-required-checkbox" class="col-12 col-sm-6 col-lg-auto"
    disabled
    name="required"
    [(ngModel)]="settings.required"
  >
    {{ 'cookieSettings.banner.required.title' | translate }}
  </mui-checkbox>
  <mui-checkbox
    id="cookies-statistics-checkbox" class="col-12 col-sm-6 col-lg-auto"
    [ngModel]="settings.statistics"
    [disabled]="formDisabled"
    (ngModelChange)="valueChanged('statistics', $event)"
    name="statistics">
    {{ 'cookieSettings.banner.analysis.title' | translate }}
  </mui-checkbox>
</div>
